/* eslint-disable */
export default {
  ringing: 'Chiamata in entrata',
  callConnected: 'Chiamata connessa',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
